/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function() {
  'use strict';
  var CreasStatoAffidamentoCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    $uibModal,
    $sce,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    dettPraticaSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.$sce = $sce;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    this.idPratica = dettPraticaSrvc.datiPratica.idPratica;
    this.dettPraticaSrvc = dettPraticaSrvc;
    
    // Spinner
    this.spinner = this.dettPraticaSrvc.spinner;
    this.subSpinner = {
      utilizzi: false
    };
    
    // Filtro visualizzazione utilizzi estinti
    this.visualizzaEstinti = false;
    this.utilizziAffidamento = [];
    var self = this;

    /**
	 * @ngdoc method
	 * @name promiseUtilizzi
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @description Effettua una chiamata http per eseguire la ricerca degli
	 *              utilizzi inerenti l'affidamento
	 * @param {boolean}
	 *            visualizzaEstinti - Filtro che permette di richiedere o meno
	 *            anche gli utilizzi estinti
	 * @return {Promise} - Ritorna una promise contenente gli utilizzi trovati
	 *         in base ai filtri di ricerca
	 */
    this.promiseUtilizzi = function(visualizzaEstinti) {
      var queryParamsObj = {
        estinti: visualizzaEstinti
      };
      
      var queryParams = $httpParamSerializer(queryParamsObj);
      
      return this.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PRATICHE.DETTAGLIO +
          self.idPratica +
          '/finanziamenti' +
          (queryParams ? '?' + queryParams : '')
      });
    };

    /**
	 * @ngdoc method
	 * @name ricercaUtilizzi
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @description Esegue la ricerca degli utilizzi inerenti l'affidamento
	 */
    this.ricercaUtilizzi = function() {
      self.subSpinner.utilizzi = true;
    	
      $q
        .all({
          utilizzi: self.promiseUtilizzi(self.visualizzaEstinti)
        })
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response.utilizzi)) {
              self.utilizziAffidamento = [];
              return;
            }

            self.utilizziAffidamento = response.utilizzi.data.result;
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.utilizzi);
            self.utilizziAffidamento = [];
          }
        )
        .finally(function() {
        	self.subSpinner.utilizzi = false;
        });
    };
    
    /**
	 * @ngdoc method
	 * @name generaStileStatoFido
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @description Restiutisce lo stile da applicare al testo dello stato affidamento
	 */
    this.generaStileStatoFido = function() {
    	
    	if (!self.dettPraticaSrvc.datiPratica.fidoNonOperativo) {
    		return {};
    	}
    	
    	switch(self.dettPraticaSrvc.datiPratica.fidoNonOperativo.stato) {
    		case 'DA_EROGARE':
    		case 'DA_RINNOVARE':
    			return { 'text-xl': true };
    		case 'VALIDO':
    			return { 'text-success': true };
    		case 'BLOCCATO':
    			return { 'text-danger': true };
    	}
    	
    	return {};
    }

    /**
	 * @ngdoc method
	 * @name openDettagliUtilizzo
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @description Apre una finestra modale con i dettagli delle polizze
	 *              assegnate all'utilizzo
	 * @param {Object}
	 *            utilizzo - Oggetto che rappresenta l'utilizzo di cui
	 *            visualizzare i dettagli
	 */
    this.openDettagliUtilizzo = function(utilizzo) {
      var modalController = function(
        $scope,
        $modalInstance,
        $http,
        $q,
        $state,
        LabelSrvc,
        CreasMessaggiFctr,
        CreasDettaglioPraticaSrvc,
        items
      ) {
    	this.$state = $state;
        $scope.msg = LabelSrvc.getLabel;
        $scope.utilizzo = items.utilizzo;
        $scope.polizzeUtilizzo = [];
        $scope.spinner = false;
                
        $scope.stampaLetteraUtilizzo = function() {
        	$scope.spinner = true;
        	
        	$http({
    			method: 'POST',
    			url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + CreasDettaglioPraticaSrvc.datiPratica.idPratica + '/richiestautilizzo',
    			data: utilizzo
    		}) 
    		.then(
    			function(response) {
    				$scope.download(response.data.result, 'lettera-utilizzo.pdf');
    			},
    			function(reason) {
    				CreasMessaggiFctr.processaResponse(reason);
    			}
    		).finally(function() {
    			$scope.spinner = false;
            });
        }
        
        // Converte la stringa di dati a 64 bit in byteArrays
        $scope.b64toByteArrays = function(b64Data, sliceSize) {
              sliceSize = sliceSize || 512;
              var byteCharacters = atob(b64Data);
              var byteArrays = [];

              for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                          byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
              }
              return byteArrays;
        };

        // Genera un oggetto di tipo Blob (per IE) o di tipo File e fa partire il download
        $scope.download = function(strData, fileName) {
              var byteArrays = $scope.b64toByteArrays(strData);

              var isChromium = window.chrome, winNav = window.navigator, vendorName = winNav.vendor, isOpera = winNav.userAgent.indexOf("OPR") > -1, isIEedge =
                          winNav.userAgent.indexOf("Edge") > -1, isIOSChrome = winNav.userAgent.match("CriOS");
                          
              var blob = null;
              var blobUrl = null;
              if (isIOSChrome ||
                    (isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera === false && isIEedge === false)) {
                    // Google Chrome
                    blob = new Blob(byteArrays, {
                         type : 'application/octet-stream'
                    });
                    blobUrl = URL.createObjectURL(blob);
                    // soluzione per costringere chrome a mostrare nome ed estensione del file
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = blobUrl;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(fileUrl);
                    a.parentNode.removeChild(a);
              } else {
                    // non Google Chrome
                    // Blob per internet explorer
                    if (navigator.msSaveOrOpenBlob) {
                         blob = new Blob(byteArrays, {
                               type : 'application/octet-stream'
                         });
                         blobUrl = URL.createObjectURL(blob);
                          navigator.msSaveOrOpenBlob(blob, fileName);
                    } // File per altri browser
                    else {
                         var file = new File(byteArrays, fileName, {
                               type : 'application/octet-stream;'
                         });
                         var fileUrl = URL.createObjectURL(file);
                          window.open(fileUrl);
                    }
              }
        };

        $scope.ok = function() {
          $modalInstance.close();
        };
      };

      modalController.$inject = [
        '$scope',
        '$modalInstance',
        '$http',
        '$q',
        '$state',
        'LabelSrvc',
        'CreasMessaggiFctr',
        'CreasDettaglioPraticaSrvc',
        'items'
      ];

      this.$uibModal.open({
        animation: true,
        templateUrl: 'dettagliUtilizzo.tmpl.html',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          items: function() {
            return {affidamento: self.dettPraticaSrvc.datiPratica.fidoNonOperativo.idFidoNonOperativoPMI, utilizzo: utilizzo};
          }
        },
        controller: modalController
      });
    };
    
    /**
	 * @ngdoc method
	 * @name richiediAffidamento
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @description Avvia la richiesta di affidamento per la pratica
	 */
    this.richiediAffidamento = function() {
    	self.spinner.pratica = true;
    	
		self.$http({
			method: 'PUT',
			url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + self.dettPraticaSrvc.datiPratica.idPratica + '/richiediFido'
		})
		.then(
			function(response) {
				if (self.messaggiFctr.processaResponse(response)) {
					return;
				}
				
				dettPraticaSrvc.datiPratica = response.data.result;
				dettPraticaSrvc.generaTabs();
			},
			function(reason) {
				self.messaggiFctr.processaResponse(reason);
			}
		).finally(function() {
        	self.spinner.pratica = false;
        });
    }
    
    /**
	 * @ngdoc method
	 * @name rinnovaAffidamento
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @description Avvia la procedura di rinnovo affidamento per la pratica
	 */
    this.rinnovaAffidamento = function() {
    	self.spinner.pratica = true;
    	
    	self.$http({
			method: 'PUT',
			url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + self.dettPraticaSrvc.datiPratica.idPratica + '/rinnovaFido'
		})
		.then(
			function(response) {
				if (self.messaggiFctr.processaResponse(response)) {
					return;
				}
				 self.$state.go('creas-dettaglio-pratica', {
			    	  ndg: response.data.result.intestatario.ndg,
			    	  idPratica: response.data.result.idPratica
			      });				
			},
			function(reason) {
				self.messaggiFctr.processaResponse(reason);
			}
		).finally(function() {
			self.spinner.pratica = false;
        });
    }
    
    /**
	 * @ngdoc method
	 * @name finanziaPolizze
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @description Porta la pratica al passaggio di finanziamento polizze
	 */
    this.finanziaPolizze = function() {
    	self.spinner.pratica = true;
    	
    	self.$http({
			method: 'PUT',
			url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + self.dettPraticaSrvc.datiPratica.idPratica + '/finanziaPolizze'
		})
		.then(
			function(response) {
				if (self.messaggiFctr.processaResponse(response)) {
					return;
				}
				
				dettPraticaSrvc.datiPratica = response.data.result;
				dettPraticaSrvc.generaTabs();
			},
			function(reason) {
				self.messaggiFctr.processaResponse(reason);
			}
		).finally(function() {
			self.spinner.pratica = false;
        });
    }
    
    /**
	 * @ngdoc method
	 * @name totaleErogato
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @description Calcola e restituisce il totale degli importi erogati per gli affidamenti
	 * @returns {number} La somma degli importi erogati
	 */
    this.totaleErogato = function() {
    	var tot = 0;
    	
    	if (self.utilizziAffidamento && self.utilizziAffidamento.length > 0) {
    		for(var i = 0; i < self.utilizziAffidamento.length; i++) {
    			tot = tot + self.utilizziAffidamento[i].importoErogato;
    		}
    	} 
    	
    	return tot;
    }
    
    /**
	 * @ngdoc totaleResiduo
	 * @name totaleErogato
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasStatoAffidamento
	 * @description Calcola e restituisce il totale degli importi residui da erogare per gli affidamenti
	 * @returns {number} La somma degli importi residui da erogare
	 */
    this.totaleResiduo = function() {
    	var tot = 0;
    	
    	if (self.utilizziAffidamento && self.utilizziAffidamento.length > 0) {
    		for(var i = 0; i < self.utilizziAffidamento.length; i++) {
    			tot = tot + self.utilizziAffidamento[i].importoResiduo;
    		}
    	} 
    	
    	return tot;
    }

    // Eseguo di default una ricerca per visualizzare gli utilizzi correnti
    self.ricercaUtilizzi();
  };

  CreasStatoAffidamentoCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    '$uibModal',
    '$sce',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'CreasDettaglioPraticaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasStatoAffidamento/creasStatoAffidamento.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasStatoAffidamentoComponent = {
    bindings: {},
    controller: CreasStatoAffidamentoCtrl,
    controllerAs: 'creasStatoAffidamentoCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasStatoAffidamento', CreasStatoAffidamentoComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasStatoAffidamento/creasStatoAffidamento.cmpt.js
// module id = 17
// module chunks = 0 1